module.exports = __webpack_public_path__ + "static/media/carrie-beaird.f43f034d.jpg";